import React, {useEffect, useState} from 'react';
import Head from 'next/head';
import { LicenseInfo } from '@mui/x-license-pro';
import TagManager from "react-gtm-module"

LicenseInfo.setLicenseKey( process.env.MUI_LICENSE_KEY );

import ReactGA from "react-ga4";

import { config } from '@fortawesome/fontawesome-svg-core';
import withRedux from 'next-redux-wrapper';
import { getCLS, getFID, getLCP, ReportHandler } from 'web-vitals';

import {useStore, wrapper} from '../redux/store'

import '@fortawesome/fontawesome-svg-core/styles.css';
config.autoAddCss = false;
import {Provider, useSelector} from 'react-redux'

import '../styles/globals.scss';
// import dynamic from "next/dynamic";

import "../styles/property.css"
import "../styles/album.css"
import "react-loading-skeleton/dist/skeleton.css";
import Checkers from "../helpers/class/Checkers";
import {fetchBuilderSettingByKey, scrollToAnchor} from "../helpers/MethodHelper";
import Layout from "../components/Layout";
import Header from "../components/Header";
import BottomSections from "../components/BottomSections";
import {Fancybox} from "@fancyapps/ui/dist/fancybox.esm";
import {useRouter} from "next/router";

declare global {
    interface Window {
        dataLayer: any;
        designMode: any;
    }
}

function MyApp ({ Component, pageProps }) {
    // const store = useStore( pageProps.initialReduxState )
    const {store, props} = wrapper.useWrappedStore(pageProps);

    const settings = store.getState().builderSettingsData.settings

    const pageId = store.getState().propertiesParams.page_id

    const servicesGoogleTagManagerId = settings != null ? settings.servicesGoogleTagManagerId : null

    const servicesMetaPixelId = settings != null ? settings.servicesMetaPixelId : null

    useEffect(() => {
        if (Checkers.isValidString(servicesGoogleTagManagerId)) {
            TagManager.initialize({gtmId: servicesGoogleTagManagerId});
        }
    }, []);

    if (Checkers.isValidPositiveNumber(pageId) && pageId != 1427) {
        ReactGA.initialize("G-XELB2CP715");
    }

    const getLayout = Component.getLayout ?? ((page) => page)

    const router = useRouter()

    useEffect(() => {
        const CLASS_NAME = 'no-search-bar'

        const update = () => {
            const hasSearchBar = !!document.getElementById('search_bar')
            document.body.classList.toggle(CLASS_NAME, !hasSearchBar)
        }

        update()

        // If #search_bar is mounted/unmounted after initial render, track it.
        const observer = new MutationObserver(update)
        observer.observe(document.body, { childList: true, subtree: true })

        return () => observer.disconnect()
    }, [router.asPath])

    useEffect(() => {
        const handleClick = (e: MouseEvent) => {
            const anchor = (e.target as HTMLElement)?.closest?.('a[href*="#"]') as HTMLAnchorElement | null
            if (!anchor) return
            
            if (anchor.getAttribute('data-bs-toggle') === 'tab' || anchor.getAttribute('data-toggle') === 'tab' || anchor.getAttribute('role') === 'tab') return

            const href = anchor.getAttribute('href')
            if (!href) return

            const hashIndex = href.indexOf('#')
            if (hashIndex === -1) return

            const hash = href.slice(hashIndex + 1)
            const path = href.slice(0, hashIndex)

            if (hash.length === 0) {
                e.preventDefault()
                return
            }

            const stripTrailingSlash = (u: string) => u.replace(/\/+$/, '')
            const currentPage = stripTrailingSlash(window.location.origin + window.location.pathname)
            const isSamePage = path === '' || stripTrailingSlash(path) === stripTrailingSlash(window.location.pathname) || stripTrailingSlash(path) === currentPage
            if (!isSamePage) return

            if (scrollToAnchor(hash)) {
                e.preventDefault()
            }
        }

        document.addEventListener('click', handleClick)
        return () => document.removeEventListener('click', handleClick)
    }, [])

    useEffect(() => {
        const handleRouteChangeStart = () => {
            try {
                sessionStorage.setItem(
                    'lastPagePath',
                    window.location.pathname + window.location.search + window.location.hash
                )
            } catch (e) {}
        }
        router.events.on('routeChangeStart', handleRouteChangeStart)
        return () => router.events.off('routeChangeStart', handleRouteChangeStart)
    }, [router])

    useEffect(() => {
        const tryScrollToCurrentHash = () => {
            const hash = window.location.hash.replace(/^#/, '')
            if (!hash) return

            let attempts = 0
            const tryScroll = () => {
                if (scrollToAnchor(hash)) return
                attempts += 1
                if (attempts < 20) setTimeout(tryScroll, 100)
            }
            tryScroll()
        }

        router.events.on('routeChangeComplete', tryScrollToCurrentHash)

        window.addEventListener('hashchange', tryScrollToCurrentHash)
        window.addEventListener('popstate', tryScrollToCurrentHash)

        return () => {
            router.events.off('routeChangeComplete', tryScrollToCurrentHash)
            window.removeEventListener('hashchange', tryScrollToCurrentHash)
            window.removeEventListener('popstate', tryScrollToCurrentHash)
        }
    }, [router])

    return (
        <>
            {
                getLayout(
                    <Provider store={store}>
                        <Component {...props} />
                    </Provider>
                )
            }
            {
                Checkers.isValidString(servicesMetaPixelId) &&
                <Head>
                    {/* Meta Pixel base code (https://developers.facebook.com/docs/meta-pixel/get-started) */}
                    <script
                        dangerouslySetInnerHTML={{__html: `
                            !function(f,b,e,v,n,t,s)
                            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                            n.queue=[];t=b.createElement(e);t.async=!0;
                            t.src=v;s=b.getElementsByTagName(e)[0];
                            s.parentNode.insertBefore(t,s)}(window, document,'script',
                            'https://connect.facebook.net/en_US/fbevents.js');
                            fbq('init', '${servicesMetaPixelId}');
                            fbq('track', 'PageView');
                        `}}
                    />
                    <noscript
                        dangerouslySetInnerHTML={{__html: `
                            <img height="1" width="1" style="display:none"
                                 src="https://www.facebook.com/tr?id=${servicesMetaPixelId}&ev=PageView&noscript=1"/>
                        `}}
                    />
                </Head>
            }
        </>
        // <Layout>
        //     <Provider store={store}>
        //         <Header referer={urlHref} {...props} />
        //         <Component {...props} />
        //         <BottomSections {...props} />
        //     </Provider>
        // </Layout>

    )
}

export function reportWebVitals ( metric ) {
  window.dataLayer = window.dataLayer || [];
  function sendToGTM ( name, delta, id ) {
    // Assumes the global `dataLayer` array exists, see:
    // https://developers.google.com/tag-manager/devguide
    window.dataLayer.push({
      event: 'web-vitals',
      event_category: 'Web Vitals',
      event_action: name.name,
      // Google Analytics metrics must be integers, so the value is rounded.
      // For CLS the value is first multiplied by 1000 for greater precision
      // (note: increase the multiplier for greater precision if needed).
      event_value: Math.round( name.name === 'CLS' ? name.delta * 1000 : name.delta ),
      // The 'id' value will be unique to the current page load. When sending
      // multiple values from the same page (e.g. for CLS), Google Analytics can
      // compute a total by grouping on this ID (note: requires `eventLabel` to
      // be a dimension in your report).
      event_label: name.id,
    });
  }
  if ( metric.label == 'web-vital' ) {
    getCLS( sendToGTM as ReportHandler );
    getFID( sendToGTM as ReportHandler );
    getLCP( sendToGTM as ReportHandler );
  }
}

// export default MyApp;

// export default withRedux( useStore )( MyApp );
// export default wrapper.withRedux(MyApp)

export default MyApp
